import React from 'react';

/**
 * SpeakingState - Shows static ellipse and animated green waves when AI is talking
 */
export default function SpeakingState() {
  return (
    <div className="ai-state-container">
      {/* Main circle - static ellipse when AI is speaking */}
      <div className="ai-circle-background">
      </div>
  
      {/* Enhanced sound bars - inside the circle */}
      <div className="ai-speaking-bars-inside">
        <div className="ai-bar ai-bar-1"></div>
        <div className="ai-bar ai-bar-2"></div>
        <div className="ai-bar ai-bar-3"></div>
        <div className="ai-bar ai-bar-4"></div>
        <div className="ai-bar ai-bar-5"></div>
        <div className="ai-bar ai-bar-6"></div>
        <div className="ai-bar ai-bar-7"></div>
        <div className="ai-bar ai-bar-8"></div>
        <div className="ai-bar ai-bar-9"></div>
      </div>
      
      {/* Visual indicator that AI is speaking 
      <div className="ai-status-text">
        <span className="ai-speaking-text">Hablando...</span>
      </div>
      */}
    </div>
  );
}
